import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import Header from "@/components/Header";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Practice from "@/pages/Practice";
import Admin from "@/pages/Admin";
import Pricing from "@/pages/Pricing";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import Bookmarks from "@/pages/Bookmarks";
import SharedSet from "@/pages/SharedSet";
import Discover from "@/pages/Discover";

function App() {
    return (
        <div className="App min-h-screen bg-background">
            <BrowserRouter>
                <AuthProvider>
                    <Header />
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/pricing" element={<Pricing />} />
                        <Route path="/payment/success" element={<PaymentSuccess />} />
                        <Route path="/payment/cancel" element={<PaymentCancel />} />
                        <Route path="/shared/:token" element={<SharedSet />} />
                        <Route path="/discover" element={<Discover />} />
                        <Route
                            path="/dashboard"
                            element={<ProtectedRoute><Dashboard /></ProtectedRoute>}
                        />
                        <Route
                            path="/practice"
                            element={<ProtectedRoute><Practice mode="practice" /></ProtectedRoute>}
                        />
                        <Route
                            path="/exam"
                            element={<ProtectedRoute><Practice mode="exam" /></ProtectedRoute>}
                        />
                        <Route
                            path="/bookmarks"
                            element={<ProtectedRoute><Bookmarks /></ProtectedRoute>}
                        />
                        <Route
                            path="/admin"
                            element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>}
                        />
                    </Routes>
                    <Toaster richColors position="top-right" />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
